import { Component, Input, OnInit } from '@angular/core';
import {
  SmartfeedActivityPayloadError,
  SmartfeedActivityPayloadFeedDone,
  SmartfeedActivityPayloadFoodSensor,
  SmartfeedActivityPayloadOtaTaskUpgradeStarted,
  SmartfeedActivityPayloadScheduleSettings,
  SmartfeedActivityPayloadStatus,
} from '@model/product/smartfeed/activity/smartfeed-activity-payload.model';
import { SmartfeedMessageType } from '@model/product/smartfeed/activity/smartfeed-activity-type.model';

@Component({
  selector: 'app-smartfeed-latest-messages-payload',
  templateUrl: './smartfeed-latest-messages-payload.component.html',
  styleUrls: ['./smartfeed-latest-messages-payload.component.scss'],
})
export class SmartfeedLatestMessagesPayloadComponent
  implements OnInit {
  SmartfeedMessageType;

  @Input()
  messageType: SmartfeedMessageType;

  @Input()
  payload:
    | SmartfeedActivityPayloadFeedDone
    | SmartfeedActivityPayloadScheduleSettings
    | SmartfeedActivityPayloadFoodSensor
    | SmartfeedActivityPayloadOtaTaskUpgradeStarted
    | SmartfeedActivityPayloadStatus
    | SmartfeedActivityPayloadError;

  constructor() {}

  ngOnInit() {}

  // PayloadType(): string {
  //   switch (this.messageType) {
  //     case SmartfeedMessageType.FEED_DONE:
  //       return '';
  //     case SmartfeedMessageType.FOOD_GOOD:
  //       return '';
  //     case SmartfeedMessageType.FOOD_UNKNOWN:
  //       return '';
  //     case SmartfeedMessageType.WILL_MESSAGE:
  //       return '';
  //     case SmartfeedMessageType.OTA_TASK_UPGRADE_STARTED:
  //       return '';
  //     case SmartfeedMessageType.SHUTDOWN:
  //       return 'Shutdown';
  //     case SmartfeedMessageType.FOOD_SENSOR:
  //       return 'Food Sensor';
  //     case SmartfeedMessageType.SCHEDULE_SETTINGS:
  //       return 'Schedule';
  //     case SmartfeedMessageType.STATUS:
  //       return 'Status';
  //     case SmartfeedMessageType.FEED_ERROR_MOTOR_SWITCH:
  //     case SmartfeedMessageType.FEED_ERROR_MOTOR_CURRENT:
  //     case SmartfeedMessageType.OTA_TASK_UPGRADE_FAILED:
  //       return 'Error';
  //   }
  // }
}
